import startCase from 'lodash/startCase';

import { GET_UNIT_ACTIVITY_OVERVIEW_SUCCESS } from '../actionConstants';

import { loadUser } from '../utils';

export const getActivityOverviewLink = (key, action) => {
  const { buildingId, unitId } = action;

  const buildingUrl = `building/${buildingId}`;
  const buildingQuery = `building=${buildingId}`;
  const unitQuery = `unit=${unitId}`;
  const paginationQuery = `limit=${loadUser()?.defaultPaginationLimit}`;
  const defaultQuery = `${buildingQuery}&${unitQuery}&${paginationQuery}&offset=0`;

  switch (key) {
    // TODO: most of the endpoints do not support the 'unit' filter - should be checked when API is ready
    case 'activeServiceRequests':
      return `/${buildingUrl}/service-requests?${defaultQuery}&ordering=-updated_at&status=pending`;
    case 'serviceRequestsCreated':
      return `/${buildingUrl}/service-requests?${defaultQuery}&ordering=-updated_at&status=null`;
    case 'positiveServiceRequestFeedback':
      return `/${buildingUrl}/service-requests?${defaultQuery}&ordering=feedback_vote&status=resolved&positive_feedback=true`;
    case 'negativeServiceRequestFeedback':
      return `/${buildingUrl}/service-requests?${defaultQuery}&ordering=feedback_vote&status=resolved&positive_feedback=false`;
    case 'deliveries':
      return `/${buildingUrl}/deliveries?${defaultQuery}`;
    case 'openDeliveries':
      return `/${buildingUrl}/deliveries?${defaultQuery}&sign_out_state=pending`;
    case 'signOutPendingDeliveries':
      return null; // when there is a dedicated filter and action - `/${buildingUrl}/deliveries?${defaultQuery}&sign_out_state=pending`;
    case 'reservations':
      return `/${buildingUrl}/amenity/reservations?${defaultQuery}`;
    case 'activeVisitors':
      return `/${buildingUrl}/visitors?${defaultQuery}&status=active&role=6`;
    case 'visitorsAdded':
      return `/${buildingUrl}/visitors?${defaultQuery}&status=null&role=6`;
    case 'visitorsEntries':
      return `/visitors/log/?${defaultQuery}&ordering=-created_at&role=6`;
    case 'messagesSent':
      return `/carson-activity?action_name=message_send&${defaultQuery}&ordering=-created_at`;
    case 'onlinePaymentsAccessed':
      return `/carson-activity?action_name=accessed_payments&${defaultQuery}&ordering=-created_at`;
    case 'cameraViewings':
      return `/carson-activity?action_name=view_camera&${defaultQuery}&ordering=-created_at`;
    case 'intercomCallsReceived':
      return `/carson-activity?action_name=initiate_resident_call&${defaultQuery}&ordering=-created_at`;
    case 'doorOpenings':
      return `/carson-activity?action_name=open_door&${defaultQuery}&ordering=-created_at`;
    case 'assignedAccessCards':
      return null; // has only create / update / delete actions on carson activity
    case 'all':
      return `/carson-activity?${defaultQuery}&ordering=-created_at`;
    default:
      return '#';
  }
};

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_UNIT_ACTIVITY_OVERVIEW_SUCCESS: {
      const data = action?.res?.data ?? {};
      const overview = Object.keys(data).map((key) => ({
        action: startCase(key),
        link: getActivityOverviewLink(key, action),
        lastRecords: data[key].last_30_days,
        total: data[key].total,
      }));
      return {
        [action.unitId]: overview,
      };
    }
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
